import React from 'react';
import { IconProps } from './icon.types';

function IconPlus(props: IconProps) {
  const { customClassName = '', customStyle = {} } = props;

  return (
    <svg
      className={customClassName}
      style={customStyle}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8125 6C11.8125 6.3105 11.5605 6.5625 11.25 6.5625H6.5625V11.25C6.5625 11.5605 6.3105 11.8125 6 11.8125C5.6895 11.8125 5.4375 11.5605 5.4375 11.25V6.5625H0.75C0.4395 6.5625 0.1875 6.3105 0.1875 6C0.1875 5.6895 0.4395 5.4375 0.75 5.4375H5.4375V0.75C5.4375 0.4395 5.6895 0.1875 6 0.1875C6.3105 0.1875 6.5625 0.4395 6.5625 0.75V5.4375H11.25C11.5605 5.4375 11.8125 5.6895 11.8125 6Z"
        fill="#25314C"
      />
    </svg>
  );
}

export default IconPlus;
